// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"113":"40e7d09b","139":"dcae09a8","153":"05d28d4c","428":"ec74b318","534":"81aee003","858":"67cdf052"}[chunkId] + ".chunk.css";
};